import axiosInstance from "./axiosInstance";

// Subscribe to newsletter
export const subscribeNewsletter = async (email) => {
  try {
    const response = await axiosInstance.post("/newsletters/subscribe", {
      email,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Unsubscribe from newsletter (requires token in query string)
export const unsubscribeNewsletter = async (token) => {
  try {
    const response = await axiosInstance.post(
      `/newsletters/unsubscribe?id=${token}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
